import { useTranslation } from 'react-i18next';

import { DataPanelAutoWrapInlineItem, DataPanelItem, Divider, NgCopyButton } from '@/ui';
import type { EedEmergencyContact } from '../../api/incidentDetailApi';

export type EedEmergencyContactPanelProps = {
  contacts?: readonly EedEmergencyContact[] | null;
};

export function EedEmergencyContactPanel({ contacts }: EedEmergencyContactPanelProps) {
  const { t } = useTranslation();

  if (contacts == null || contacts.length === 0) {
    return null;
  }

  return (
    <DataPanelItem title={t('Incident_InfoPanel_ClosePersonContact')}>
      {contacts.map((contact, index) => (
        <div key={`${contact.name ?? ''}-${contact.tel ?? ''}-${index}`}>
          <div className="d-flex justify-content-between align-items-center">
            <div className="medium px-1">{contact.name}</div>
            <div className="d-flex align-items-center medium">
              <div>
                <a href={`tel: ${contact.tel ?? ''}`}>{contact.tel}</a>
              </div>
              <NgCopyButton valueToCopy={contact.tel ?? ''} cssClass="px-1" />
            </div>
          </div>
          <DataPanelAutoWrapInlineItem
            title={t('Incident_InfoPanel_EED_EmergencyContact_Relationship')}
            value={contact.relationship ?? undefined}
            showEmptyPlaceholder
          />
          <Divider dense />
        </div>
      ))}
    </DataPanelItem>
  );
}
